module.exports = __webpack_public_path__ + "assets/img/00062.ce54dabc.png";